import React from 'react';
import { Link } from 'react-router-dom';
import '../pages/HomePage.css';

const PAPER_ASSET = 'https://app.paper.design/file-assets/01KJMJX949QFE2956T0Y37HAN1';
const CTA_IMAGE = `${PAPER_ASSET}/023400EDGXCGNXMWCRZWQDAF73.webp`;

// The landing page's pre-footer CTA card, shared so subpages render the
// exact same section above their footer.
export default function PaperCta() {
  return (
    <section className="paper-cta paper-container">
      <img src={CTA_IMAGE} alt="" />
      <div>
        <span>GET STARTED TODAY</span>
        <h2>Transform the way your team operates</h2>
        <Link to="/register" className="paper-button paper-button-light">
          <span>Hire Your First Staff Member</span>
        </Link>
      </div>
    </section>
  );
}
